
/* injects from baggage-loader */

//Trocar por Objeto e fazer verificação de nível
export const balloonsDone = {
	route:'main.stage-sixth',
	dialog: ["Muito bem! <br>Você completou corretamente essas <br>páginas. Mas parece que você já <br>conquistou a premiação desta <br>atividade.",
    "Para finalizar o álbum, basta <br> juntar as peças e montar  o quebra-cabeça da página final. vamos lá?!",
    "Você também pode repetir a <br>atividade que acabou de fazer!"],
    confirmation:true
}

export const balloonsFirst = {
	route:'main.stage-sixth',
	dialog: ["Parabéns! <br> Você preencheu todas as páginas do <br> seu álbum e acaba de ganhar a última peça do seu quebra-cabeça!",
    "Para finalizar o álbum, basta <br> juntar as peças e montar  o quebra-cabeça da página final. vamos lá?!",
    "Você também pode repetir a <br>atividade que acabou de fazer!"],
    confirmation:true
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-sixth/stage-sixth.const.js